var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalletJackGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_16653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 6.78759C30.8379 3.69785 26.7282 2 22.3606 2C17.987 2 13.8833 3.69785 10.7936 6.78759C7.70385 9.87732 6 13.987 6 18.3546C6 27.1918 14.3573 34.5472 18.8509 38.4948C19.4748 39.0468 20.0088 39.5208 20.4408 39.9167C20.9807 40.4207 21.6706 40.6727 22.3606 40.6727C23.0505 40.6727 23.7405 40.4207 24.2744 39.9167C24.7064 39.5208 25.2463 39.0468 25.8703 38.4948C30.3579 34.5472 38.7152 27.1918 38.7152 18.3546C38.7152 13.987 37.0173 9.87732 33.9276 6.78759Z",
    fill: "#3D8B30",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 18.2646C25.9999 19.3077 26.5718 20.2715 27.5 20.793C28.4282 21.3145 29.5719 21.3145 30.5 20.793C31.4283 20.2715 32 19.3077 32 18.2646H30.0001C30.0001 18.5227 29.8946 18.7703 29.7071 18.9528C29.5196 19.1353 29.2653 19.2378 29 19.2378C28.7348 19.2378 28.4805 19.1353 28.293 18.9528C28.1053 18.7703 28 18.5227 28 18.2646C28 18.0065 28.1053 17.7589 28.293 17.5764C28.4805 17.394 28.7348 17.2915 29 17.2915H29.9999L30.0001 9L21 12.7565V23.1304H19.9999V15.3448H15.7L12 17.7388V25.0764H13.1799C13.462 25.8325 14.052 26.442 14.8109 26.7609C15.5697 27.0797 16.4302 27.0797 17.1891 26.7609C17.948 26.442 18.538 25.8325 18.8201 25.0764H23.18C23.4646 25.8281 24.054 26.4331 24.8102 26.7494C25.5666 27.0657 26.4232 27.0657 27.1796 26.7494C27.9358 26.4331 28.5252 25.8281 28.8099 25.0764H31.9999V23.1302H28.8199C28.5353 22.3785 27.9458 21.7735 27.1895 21.4571C26.4333 21.1409 25.5766 21.1409 24.8203 21.4571C24.0641 21.7735 23.4745 22.3785 23.1899 23.1302H22.9998V14.0408L28 11.9582V15.5102C27.4149 15.7115 26.9083 16.0846 26.5501 16.5778C26.1918 17.0711 25.9996 17.6604 26 18.2644L25.9999 18.2646ZM16 25.0768C15.7348 25.0768 15.4803 24.9743 15.2928 24.7918C15.1053 24.6093 15 24.3617 15 24.1036C15 23.8455 15.1053 23.5979 15.2928 23.4155C15.4803 23.233 15.7348 23.1305 16 23.1305C16.2652 23.1305 16.5196 23.233 16.7071 23.4155C16.8946 23.5979 16.9999 23.8455 16.9999 24.1036C16.9999 24.3617 16.8946 24.6093 16.7071 24.7918C16.5196 24.9743 16.2652 25.0768 16 25.0768ZM25.9999 23.1305C26.2653 23.1305 26.5196 23.233 26.7071 23.4154C26.8946 23.5979 27.0001 23.8455 27.0001 24.1036C27.0001 24.3617 26.8946 24.6093 26.7071 24.7918C26.5196 24.9743 26.2653 25.0768 25.9999 25.0768C25.7348 25.0768 25.4805 24.9743 25.293 24.7918C25.1053 24.6093 25 24.3617 25 24.1036C25 23.8455 25.1053 23.5979 25.293 23.4154C25.4805 23.233 25.7348 23.1305 25.9999 23.1305Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_16653",
    x: 0.5,
    y: 0.5,
    width: 43.7148,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_16653"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_16653",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletJackGreenIcon);
export default __webpack_public_path__ + "static/media/PalletJackGreenIcon.aac2e6b038ba4cd19a82a66132049730.svg";
export { ForwardRef as ReactComponent };